module.exports = __webpack_public_path__ + "img/icon-ai-failed.b6d67822.svg";